import { useRef, useState } from 'react';
import HotFilterButton from '@components/organisms/hot-filters/hot-filter-button/hot-filter-button';
import { useTranslation } from 'next-i18next';
import HotFilterDialog from '@components/organisms/hot-filters/hot-filter-dialog/hot-filter-dialog';
import SortOptionsList from '@components/catalog/sort/sort-options-list';
import { handleMobileFilterBodyClass } from '@helpers/utils/catalog/catalog-ui-utils';
import useWindowSize from '@hooks/use-window-size';
import Button from '@components/atoms/button/button';
import clsx from 'clsx';
import styles from './hot-filter-sort.module.scss';

type Option = {
  text: string;
  value: string;
};

interface HotfilterSortbyProps {
  setIsFilterOpen?: (state: boolean) => void;
  dialogOffset?: 'right' | 'left';
  options: Option[];
  value: string;
  onChange: (val: string) => void;
  defaultSortValue?: string;
}

const HotfilterSort: React.FC<HotfilterSortbyProps> = ({
  setIsFilterOpen = () => {},
  dialogOffset = 'right',
  options,
  value,
  onChange,
  defaultSortValue,
}) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { isWiderThanMd } = useWindowSize();

  const handleOpenDialog = () => {
    setIsOpen((prev) => !prev);
    handleMobileFilterBodyClass(!isOpen, isWiderThanMd);
    setIsFilterOpen(!isOpen);
  };

  const handleCloseDialog = () => {
    setIsOpen(false);
    setIsFilterOpen(false);
    handleMobileFilterBodyClass(false, isWiderThanMd);
  };

  return (
    <div ref={containerRef}>
      <HotFilterButton
        ref={buttonRef}
        label={'CATALOG.FILTERS.SORT.SORT_BY'}
        onClick={() => handleOpenDialog()}
        isSelected={isOpen}
        isHighlighted={defaultSortValue && defaultSortValue !== value}
        dataCy="CATALOG.FILTERS.SORT.SORT_BY.BUTTON"
      />
      {isOpen && (
        <HotFilterDialog
          customClass={styles.hotFilterSort__dialog}
          dataCy="CATALOG.FILTERS.SORT.SORT_BY.DIALOG"
          headerLabel={'CATALOG.FILTERS.SORT.SORT_BY'}
          isDialogOpened={true}
          onClose={() => handleCloseDialog()}
          handleApplyChange={() => handleCloseDialog()}
          handleClear={() => {}}
          clickOutsideRef={containerRef}
          showCtaSection={false}
          offset={dialogOffset}
        >
          <div className={styles.hotFilterSort__sortByWrapper}>
            <SortOptionsList
              selectedValue={value}
              handleChange={onChange}
              options={options}
            />
          </div>
          <div className={styles.hotFilterSort__actionRow}>
            <Button
              disableDefaultStyling
              onClick={handleCloseDialog}
              variant={isWiderThanMd ? 'ghost' : 'primary'}
              size={isWiderThanMd ? 'none' : 'large'}
              className={clsx(styles.hotFilterSort__actionButton, styles.hotFilterSort__closeButton)}
              data-cy="CATALOG.FILTERS.SORT.SORT_BY.CLOSE_BUTTON"
            >
              {t('MODAL.BUTTON.CLOSE')}
            </Button>
          </div>
        </HotFilterDialog>
      )}
    </div>
  );
};

export default HotfilterSort;
